<template>
  <div
    v-show="!hidden"
    class="update-info"    
    @wheel.stop
    @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')"
  >
   <button class="close-button" @click="$emit('closeUpdateStatisticMenu')">×</button>
    <!-- 这里可以添加更新信息的内容 -->
    <div 
    @mousedown="startDrag"
    @mousemove="handleDrag"
    @mouseup="stopDrag"
    @mouseleave="stopDrag"
    class="update-title">申请及审核统计</div>  
    <div class="update-content">  
        <div class="condition-box">
            <div class="condition-item">                                
                <label>选择日期</label>
                <!-- <el-checkbox v-model="isDateRange">指定范围</el-checkbox>   -->
                <el-select v-model="selectedDate" placeholder="请选择类型" style="width:180px">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="提交日期" value="TJRQ"></el-option>
                    <el-option  label="审核日期(最终)" value="SHRQ"></el-option>
                    <el-option  label="审核日期(测绘院)" value="SHRQ_CHY"></el-option>
                    <el-option  label="审核日期(执法队)" value="SHRQ_ZFD"></el-option>
                    <el-option  label="审核日期(保护科)" value="SHRQ_GBK"></el-option>
                    <el-option  label="审核日期(监测科)" value="SHRQ_JCK"></el-option>
                    <el-option  label="审核日期(规自)" value="SHRQ_GZ"></el-option>
                    <el-option  label="审核日期(农村局)" value="SHRQ_NCJ"></el-option>
                </el-select> 
                <label>开始日期</label>
                <el-date-picker
                    v-model="startDate"
                    type="date"     
                    style="width: 244px;">
                </el-date-picker>
                <label>结束日期</label>
                <el-date-picker
                    v-model="endDate"
                    type="date"
                    style="width: 244px;">
                </el-date-picker>              
            </div>
            <div class="condition-item">
                <label>选择镇街</label>
                <el-select v-model="selectedZJ" placeholder="请选择">
                    <el-option  label="全区" value="全区">
                    </el-option>
                    <el-option
                        v-for="zj in zjList"
                        :key="zj.ZJ"
                        :label="zj.ZJ"
                        :value="zj.ZJ">
                    </el-option>
                </el-select>
            
                <label>选择类型</label>
                <el-select v-model="selectedLX" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="非粮化" value="非粮化"></el-option>
                    <el-option  label="非农化" value="非农化"></el-option>
                    <el-option  label="无法进入" value="无法进入"></el-option>
                </el-select>
            
                <label>选择进度</label>
                <el-select v-model="selectedJD" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="待反馈" value="审核中"></el-option>
                    <el-option  label="已反馈" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>
            
                <label>选择结果</label>
                <el-select v-model="selectedJG" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="已整改" value="已整改"></el-option>
                    <el-option  label="整改中" value="整改中"></el-option>
                    <el-option  label="拟挂账" value="拟挂账"></el-option>
                </el-select>
            </div>
            <div class="condition-item">
                <label>测绘院建议</label>
                <el-select v-model="shzt_CHY" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>                    
                    <el-option  label="待反馈" value="空"></el-option>
                    <el-option  label="待审核" value="待审核"></el-option>
                    <el-option  label="无建议" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>
            
                <label>执法队建议</label>
                <el-select v-model="shzt_ZFD" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="待反馈" value="空"></el-option>
                    <el-option  label="无建议" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>
            
                <label>保护科建议</label>
                <el-select v-model="shzt_GBK" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="待反馈" value="空"></el-option>
                    <el-option  label="无建议" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>
            
                <label>监测科建议</label>
                <el-select v-model="shzt_JCK" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="待反馈" value="空"></el-option>
                    <el-option  label="无建议" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>
            </div>
            <div class="condition-item">
                <label>外业复核</label>
                <el-select v-model="wyfh" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="无需外业" value="1"></el-option>
                    <el-option  label="需要外业" value="2"></el-option>
                    <el-option  label="外业完成" value="3"></el-option>
                </el-select>

                <label>是否拒测</label>
                <el-select v-model="sfjc" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="否" value="否"></el-option>
                    <el-option  label="是" value="是"></el-option>
                </el-select>

                <label>紧急类别</label>
                <el-select v-model="jjlb" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option v-for="item in jjlbOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>

                <label>紧急图斑</label>
                <el-select v-model="yjtb" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="是" value="是"></el-option>
                    <el-option  label="否" value="否"></el-option>
                </el-select>

                <label>规自建议</label>
                <el-select v-model="shzt_GZ" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="待反馈" value="空"></el-option>
                    <el-option  label="无建议" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>
            
                <label>农村局建议</label>
                <el-select v-model="shzt_NCJ" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="待反馈" value="空"></el-option>
                    <el-option  label="无建议" value="已通过"></el-option>
                    <el-option  label="需整改" value="未通过"></el-option>
                </el-select>  
                
                <label>未通过原因</label>
                <el-select v-model="selectedYYFL" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="撂荒" value="撂荒"></el-option>                    
                    <el-option  label="部分种植" value="部分种植"></el-option>
                    <el-option  label="未种植" value="未种植"></el-option>
                    <el-option  label="非地表种植" value="非地表种植"></el-option>
                    <el-option  label="树木" value="树木"></el-option>
                    <el-option  label="堆物堆放" value="堆物堆放"></el-option>
                    <el-option  label="道路" value="道路"></el-option>
                    <el-option  label="重新举证" value="重新举证"></el-option>
                    <el-option  label="其它" value="其它"></el-option>   
                 </el-select> 
            </div>
            <div class="condition-item">
               <label>协同认定</label>
                <el-select v-model="selectedXTRD" placeholder="请选择">
                    <el-option  label="全部" value="全部"></el-option>
                    <el-option  label="协同认定" value="协同认定"></el-option> 
                 </el-select> 
            </div>
            <div class="condition-actions">
                <button type="primary" @click="searchUpdateStatistic()">查询</button>
                <button type="primary" @click="resetConditions()">重置</button>
                <label class="stat-msg">{{ updateInfoStatstic.msg }}</label>
                <button type="primary" @click="resetChartByZJ">按镇街显示</button>
                <button type="primary" @click="resetChartByDate">按日期显示</button>
                <button type="primary" @click="resetChartByYJFL">按类型显示</button>
                <button type="primary" @click="resetChartBySHZT">按进度显示</button>
                <button type="primary" @click="resetChartByZGJG">按结果显示</button>
            </div>
            <div class="condition-actions">
              <label>显示单位</label>
              <el-radio-group v-model="unit" @change="unitChange">
                <el-radio :value="0">数量个</el-radio>
                <el-radio :value="1">面积亩</el-radio>
              </el-radio-group>
              <label>统计样式</label>
              <el-radio-group v-model="chartType" @change="chartTypeChange">
                <el-radio :value="0">柱状图</el-radio>
                <el-radio :value="1">饼状图</el-radio>
              </el-radio-group>
            </div>
            <div class="condition-chart" ref="data_chart">             
            </div>
        </div>      
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { markRaw } from 'vue';

export default {
  name: 'UpdateInfoStatistic',
  props: {
    hidden: {
      type: Boolean,
      default: false,
    }, 
    zjList: {
      type: Array,
      required: true, 
    },
    jjlbConfig: { //紧急类别配置（来自tableConfig/wthz.json的wthz_jjlb）
      type: Object,
      default: null,
    },
  },
  data() {
    return { 
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      startDate: null,
      endDate: null,
      isDateRange: false, // 控制是否显示日期范围
      selectedDate: '全部',
      selectedZJ:'全区',
      selectedLX:'全部',
      selectedJD:'全部',
      selectedJG:'全部', 
      selectedXTRD:"全部",
      shzt_CHY:"全部",
      shzt_ZFD:"全部", 
      shzt_GBK:"全部",
      shzt_JCK:"全部", 
      shzt_GZ:"全部",  
      shzt_NCJ:"全部",
      selectedYYFL:"全部",
      wyfh:"全部",
      sfjc:"全部",
      jjlb:"全部", //紧急类别（位掩码值，选项来自配置）
      yjtb:"全部", //是否紧急图斑（Flag）
      data_chart:null,  //统计图显示
      updateInfoStatstic: {
        msg: '未开始查询！',
        data: [],
      },
      chartType:0, //0柱状图，1饼状图
      unit:0, // 0:个 1:亩      
      groupBy: 'ZJ', // 分组字段
    };
  },
  computed: {
    jjlbOptions(){ //紧急类别候选项，全部来自配置，新增子类无需改代码
      return (this.jjlbConfig && this.jjlbConfig.items) ? this.jjlbConfig.items : [];
    },
  },
  watch: {
    hidden(val){ //窗体显示时重算图表尺寸，避免统计图超出窗体
      if(!val){
        this.$nextTick(()=>{
          this.safeResize();
        });
      }
    },
  },
  beforeUnmount(){
    if(this._resizeHandler){
      window.removeEventListener('resize', this._resizeHandler);
      this._resizeHandler = null;
    }
    if(this.data_chart){
      this.data_chart.dispose();
      this.data_chart = null;
    }
  },
  methods: {
    startDrag(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      if (this.$el) {
        this.offsetX = this.$el.offsetLeft; 
        this.offsetY = this.$el.offsetTop;        
        document.addEventListener('mousemove', this.drag);
        document.addEventListener('mouseup', this.stopDrag);
      }
    },
    drag(event) {
      event.stopPropagation();
      if (this.isDragging && this.$el) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        if (this.$el.style) {
          this.$el.style.left = `${this.offsetX + dx}px`;
          this.$el.style.top = `${this.offsetY + dy}px`;
        }
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    initChart(){
      const dom = this.$refs.data_chart;
      if(!dom){
        console.log('图表容器不存在！');
        return;
      }
      //复用已有实例，避免重复init；markRaw避免实例被Vue代理导致echarts内部状态异常
      const exist = echarts.getInstanceByDom(dom);
      this.data_chart = markRaw(exist || echarts.init(dom));
      this.showEchartsMsg('未开始查询！');
      if(!this._resizeHandler){ //窗体尺寸变化时自适应，避免统计图超出窗体
        this._resizeHandler = () => {
          this.safeResize();
        };
        window.addEventListener('resize', this._resizeHandler);
      }
    },
    safeResize(){
      try{
        const dom = this.data_chart && this.data_chart.getDom();
        if(!dom || !dom.clientWidth || !dom.clientHeight){ //隐藏或尺寸为0时不重算，避免echarts内部状态异常
          return;
        }
        this.data_chart.resize();
      }catch(error){
        console.log('统计图尺寸更新失败：' + error);
      }
    },
    showEchartsMsg(msg){   
      if(this.data_chart){
        var option = {
            // 自定义 graphic 来显示文字
          graphic: [
              {
                  type: 'text',
                  left: 'center',
                  top: 'center',
                  style: {
                      text:  msg,
                      fontSize: 20,
                      fill: '#FF00FF'
                  }
              }
          ],
          // 清空系列，避免与上一次查询的图表配置冲突
          series: [],
        };
        this.data_chart.setOption(option,true);
      } else{
        console.log('图表插件为空！');
      }
      
    },
    resetConditions(){  //重置所有查询条件
      this.selectedDate = '全部';
      this.startDate = null;
      this.endDate = null;
      this.isDateRange = false;
      this.selectedZJ = '全区';
      this.selectedLX = '全部';
      this.selectedJD = '全部';
      this.selectedJG = '全部';
      this.selectedXTRD = '全部';
      this.shzt_CHY = '全部';
      this.shzt_ZFD = '全部';
      this.shzt_GBK = '全部';
      this.shzt_JCK = '全部';
      this.shzt_GZ = '全部';
      this.shzt_NCJ = '全部';
      this.selectedYYFL = '全部';
      this.wyfh = '全部';
      this.sfjc = '全部';
      this.jjlb = '全部';
      this.yjtb = '全部';
      this.chartType = 0;
      this.unit = 0;
      this.groupBy = 'ZJ';
      this.updateInfoStatstic.msg = '未开始查询！';
      this.updateInfoStatstic.data = [];
      if(this.data_chart){
        this.data_chart.clear();
        this.showEchartsMsg('未开始查询！');
      }
    },
    searchUpdateStatistic(){
      if(!this.data_chart){
        this.initChart();
      }
      this.data_chart.showLoading();
      let conditions = {};
      // if(this.isDateRange && this.startDate && this.endDate){
      //   let startDateStr = `${this.startDate.getFullYear()}-${(this.startDate.getMonth() + 1).toString().padStart(2, '0')}-${this.startDate.getDate().toString().padStart(2, '0')} 00:00:00`;
      //   let endDateStr = `${this.endDate.getFullYear()}-${(this.endDate.getMonth() + 1).toString().padStart(2, '0')}-${this.endDate.getDate().toString().padStart(2, '0')} 23:59:59`;
      //   conditions['TJRQ'] = ` (STR_TO_DATE(TJRQ,'%Y/%m/%d') BETWEEN '${startDateStr}' AND '${endDateStr}') `;
      // }
      if(this.selectedDate && this.selectedDate != '全部'){
        let startDateStr = `${this.startDate.getFullYear()}/${(this.startDate.getMonth() + 1).toString().padStart(2, '0')}/${this.startDate.getDate().toString().padStart(2, '0')} 00:00:00`;
        let endDateStr = `${this.endDate.getFullYear()}/${(this.endDate.getMonth() + 1).toString().padStart(2, '0')}/${this.endDate.getDate().toString().padStart(2, '0')} 23:59:59`;
        if(this.selectedDate == 'TJRQ'){
          conditions[this.selectedDate] = ` (updateinfo.${this.selectedDate} >= '${startDateStr}' AND updateinfo.${this.selectedDate} < '${endDateStr}' AND updateinfo.STATE_ZJ = 2) `;
        }else{
          conditions[this.selectedDate] = ` (updateinfo.${this.selectedDate} >= '${startDateStr}' AND updateinfo.${this.selectedDate} < '${endDateStr}') `;
        }

      }

      if(this.selectedZJ && this.selectedZJ != '全区'){
        conditions['ZJ'] = ` updateinfo.ZJ = '${this.selectedZJ}' `;
      }
      if(this.selectedLX && this.selectedLX != '全部'){
        conditions['YJFL'] = ` YJFL = '${this.selectedLX}' `;
      }
      if(this.selectedJD && this.selectedJD!= '全部'){
        conditions['SHZT'] = ` updateinfo.SHZT = '${this.selectedJD}' `; 
      }
      if(this.selectedJG && this.selectedJG!= '全部'){
        conditions['ZGJG'] = ` updateinfo.ZGJG = '${this.selectedJG}' `;
      }
      if(this.selectedYYFL && this.selectedYYFL!= '全部'){
        conditions['YYFL'] = ` updateinfo.YYFL = '${this.selectedYYFL}' `;
      }
      if(this.selectedXTRD && this.selectedXTRD!= '全部'){
        conditions['XTRD'] = ` updateinfo.XTRD = '${this.selectedXTRD}' `;
      }
      if(this.shzt_CHY!='全部'){
        if(this.shzt_CHY == '待审核'){
          conditions['STATE_CHY'] = ` updateinfo.STATE_CHY = 1`;
        }else if(this.shzt_CHY == '空'){
          conditions['SHZT_CHY'] = ` updateinfo.SHZT_CHY = '' `;
          conditions['SHZT'] = ` updateinfo.SHZT = '审核中' `;
        }else{
          conditions['STATE_CHY'] = ` updateinfo.STATE_CHY = 2 `;
          conditions['SHZT_CHY'] = ` updateinfo.SHZT_CHY = '${this.shzt_CHY}' `;
        }
      }
      if(this.shzt_ZFD!='全部'){
        if(this.shzt_ZFD == '空'){
          conditions['SHZT_ZFD'] = ` updateinfo.SHZT_ZFD = '' `;
          conditions['SHZT'] = ` updateinfo.SHZT = '审核中' `;
        }else{
          conditions['SHZT_ZFD'] = ` updateinfo.SHZT_ZFD = '${this.shzt_ZFD}' `;
        }
      }
      if(this.shzt_GBK!='全部'){
        if(this.shzt_GBK == '空'){
          conditions['SHZT_GBK'] = ` updateinfo.SHZT_GBK = '' `;
          conditions['SHZT'] = ` updateinfo.SHZT = '审核中' `;
        }else{
          conditions['SHZT_GBK'] = ` updateinfo.SHZT_GBK = '${this.shzt_GBK}' `;
        }
      }
      if(this.shzt_JCK!='全部'){
        if(this.shzt_JCK == '空'){
          conditions['SHZT_JCK'] = ` updateinfo.SHZT_JCK = '' `;
          conditions['SHZT'] = ` updateinfo.SHZT = '审核中' `;
        }else{
          conditions['SHZT_JCK'] = ` updateinfo.SHZT_JCK = '${this.shzt_JCK}' `;
        }        
      }
      if(this.shzt_GZ!='全部'){
        if(this.shzt_GZ == '空'){
          conditions['STATE_GZ'] = ` updateinfo.SHZT_GZ = '' `;
          conditions['SHZT'] = ` updateinfo.SHZT = '审核中' `;
        }else{          
          conditions['SHZT_GZ'] = ` updateinfo.SHZT_GZ = '${this.shzt_GZ}' `;
        }        
      }
      if(this.shzt_NCJ!='全部'){
        if(this.shzt_NCJ == '空'){
          conditions['SHZT_NCJ'] = ` updateinfo.SHZT_NCJ = '' `;
          conditions['SHZT'] = ` updateinfo.SHZT = '审核中' `;
        }else{
          conditions['SHZT_NCJ'] = ` updateinfo.SHZT_NCJ = '${this.shzt_NCJ}' `;
        }
      }
      if(this.wyfh!='全部'){
        conditions['WYFH'] = ` updateinfo.WYFH = ${this.wyfh} `;
      }
      if(this.sfjc!='全部'){  //是否拒测字段位于图层表中，表名由MyMap按当前图层替换
        conditions['SFJC'] = ` #TCMC#.SFJC = '${this.sfjc}' `;
      }
      if(this.jjlb!='全部'){  //紧急类别为位掩码(JJLB)，按位与筛选；字段位于图层表中
        let bit = Number(this.jjlb);
        conditions['JJLB'] = ` (#TCMC#.JJLB & ${bit}) = ${bit} `;
      }
      if(this.yjtb!='全部'){  //是否紧急图斑：Flag 非空即为紧急图斑
        conditions['YJTB'] = this.yjtb == '是' ? ` (#TCMC#.Flag IS NOT NULL AND #TCMC#.Flag <> '') ` : ` (#TCMC#.Flag IS NULL OR #TCMC#.Flag = '') `;
      }
      this.$emit('searchUpdateStatistic',conditions);     
    },

    updateChart(updateData){  //更新数据和chart
      this.updateInfoStatstic = updateData;
      this.resetChart('ZJ');
    },

    resetChartByDate(){  //更新数据和chart
      this.groupBy = 'TJRQ';
      this.resetChart();      
    },

    resetChartByZJ(){  //更新数据和chart
      this.groupBy = 'ZJ';
      this.resetChart();
    },

    resetChartByYJFL(){  //更新数据和chart
      this.groupBy = 'YJFL';
      this.resetChart();
    },
    resetChartBySHZT(){  //更新数据和chart
      this.groupBy = 'SHZT';
      this.resetChart();
    },
    resetChartByZGJG(){  //更新数据和chart
      this.groupBy = 'ZGJG';
      this.resetChart();
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    resetChart(){  //重置数据和chart
      if(!this.data_chart){
        this.initChart();
      }
      if(this.updateInfoStatstic.data.length == 0){ 
        this.data_chart.hideLoading(); 
        this.showEchartsMsg('未查询到数据！');      
        return;
      }
      
      let groupBy = this.groupBy;
      let data = {};     
      if(this.unit == 1){  //亩
        if(this.groupBy == 'TJRQ'){  //如果是日期格式
          this.updateInfoStatstic.data.forEach((item)=>{
            let key = this.formatDate(new Date(item[groupBy]));
            if(data[key] == null){
              data[key] = item['Area'];
            }else{
              data[key] += item['Area'];
            }
          }) 
        }else{
          this.updateInfoStatstic.data.forEach((item)=>{
            let key = item[groupBy];
            if(data[key] == null){
              data[key] = item['Area'];
            }else{
              data[key] += item['Area'];
            }          
          })
        }        
      }else{  //个     
        if(this.groupBy == 'TJRQ'){  //如果是日期格式
          this.updateInfoStatstic.data.forEach((item)=>{
            let key = this.formatDate(new Date(item[groupBy]));
            if(!data[key]){
              data[key] = 1;
            }else{
              data[key] += 1;
            }
          }) 
        }else{
          this.updateInfoStatstic.data.forEach((item)=>{
            let key = item[groupBy];          
            if(!data[key]){
              data[key] = 1;
            }else{            
              data[key] += 1;
            }          
          })
        } 
        
      }
     
      let xdata = [];
      let ydata = [];
      if(this.unit == 1){ //亩
        for(let key in data){
          let shkey = this.shztToString(key);
          xdata.push(shkey);
          ydata.push(data[key].toFixed(2));
        }
      }else{ //个
        for(let key in data){
          let shkey = this.shztToString(key);
          xdata.push(shkey);
          ydata.push(data[key]);
        }
      }
      
      let option = {};
      if(this.chartType == 0){  //柱状图
        option ={
          grid:{
              left:'8%',
              right:'2%',
              top:'8%',
              bottom:'20%',
          },                    
          xAxis: {
              type: 'category',
              data: xdata,
              axisLabel: {
                  rotate: 90, // 文字旋转 90 度，竖排显示
                  overflow: 'break', // 文字溢出处理方式，break 会换行显示
                  interval: 0 // 强制显示所有标签
                  }
              },
          yAxis: {
              type: 'value'
              },
          series:[{
                  name:'整改图斑',
                  data:ydata,
                  type:'bar',
                  label: {
                      show: true, // 显示标签
                      position: 'top', // 标签位置在柱子顶部
                      formatter: '{c}', // 格式化标签内容，{c} 表示数据值
                      textStyle:{
                          fontSize:10,
                          color:'blue'
                      }
                  }
              },                  
          ],
          legend: {
              orient: 'horizontal', // 图例布局为水平方向
              right: '5%', // 距离容器右侧 5%
              top: '3%' // 距离容器顶部 5%
          },
        }
      }else{  //饼状图
        let pieData = [];
        for(let i=0;i<xdata.length;i++){
          let item = {
            value:ydata[i],
            name:xdata[i]
          }
          pieData.push(item);
        }
        option = {
          series:[
            {
              name:'整改图斑',
              type:'pie',
              radius: ['40%', '70%'], 
              data:pieData,
              itemStyle: {
                borderRadius: 10, // 设置圆角
                borderColor: '#fff', // 设置边框颜色
                borderWidth: 2 // 设置边框宽度
              },
            }
          ]
        }

      }
      this.data_chart.hideLoading();
      this.data_chart.setOption(option,true);         
    },

    unitChange(){  //切换单位      
      this.resetChart();
    },
    chartTypeChange(){  //切换样式
      this.resetChart();
    },
    shztToString(shzt){
      switch(shzt){
        case '审核中':
          return '待反馈';
        case '已通过':
          return '已反馈';
        case '未通过':
          return '需整改';
        default:
          return shzt;
      } 
    }
  },  
}
</script>

<style>
.update-info {
  position: fixed;
  width: 60vw;
  top: 35vh;   
  left: 400px;
  height: 60vh;
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  padding: 10px;
  z-index: 1003;
  border: 1px solid #292541;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.update-title {
  background-color: #e0e0e0; /* 标题栏背景颜色 */
  padding: 5px;
  margin: -10px -10px 10px -10px; /* 调整标题栏的边距 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  position:relative;
  top:0;
  z-index: 1003;
  cursor: move;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1004;
}

.update-content{
  display:flex;
  height: 95%;
}

.condition-box{
    border-radius: 5px;
    border:1px solid #292541;
    margin: 10px;
    width:100%   
}

.condition-item{
  display: flex;
  padding:2px;
  border-bottom: 1px dashed #403c3c;
}

.condition-item label,
.condition-item input,
.condition-item select,
.condition-item button,
.condition-item .el-select{
  margin: 2px;
  font-size: 14px;
  color: #666;  
  width:120px;
}

.condition-chart{
  width:90%;
  height: 25vh;
  margin: 10px;
  border:1px solid #17057a;
  border-radius: 5px;
}

/* ===== 高级查找布局：筛选项每行4个且对齐，统计图收回窗体 ===== */
.update-info{
  left: 400px;
  width: calc(100vw - 430px);
  max-width: 1700px;
  top: 8vh;
  height: 82vh;
  max-height: calc(100vh - 40px);
  box-sizing: border-box;
  overflow: hidden;
}

.update-content{
  height: auto;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.condition-box{
  display: grid;
  grid-template-columns: repeat(4, 96px minmax(0, 1fr));
  column-gap: 8px;
  row-gap: 4px;
  align-content: start;
  align-items: center;
  box-sizing: border-box;
  margin: 10px 0;
  padding: 6px 10px;
  height: auto;
  min-height: 0;
  overflow-y: auto;
}

/* 让各条件分组内的控件直接参与外层网格，实现每行4组 */
.condition-item{
  display: contents;
}

.condition-box .condition-item label{
  width: auto;
  margin: 0;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.condition-box .condition-item .el-select,
.condition-box .condition-item .el-date-editor,
.condition-box .condition-item select,
.condition-box .condition-item input{
  width: 100% !important;
  margin: 0;
  min-width: 0;
}

.condition-actions{
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  border-top: 1px dashed #403c3c;
}

.condition-actions label{
  margin: 2px;
  font-size: 14px;
  color: #666;
}

.condition-actions button{
  padding: 3px 12px;
  font-size: 14px;
  cursor: pointer;
}

.condition-actions .stat-msg{
  width: 240px;
}

.condition-chart{
  grid-column: 1 / -1;
  width: auto !important;
  height: 30vh !important;
  min-height: 180px;
  margin: 6px 0 0 0;
}
</style>